module.exports = __webpack_public_path__ + "assets/bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bad.png
// module id = 1225
// module chunks = 7